export default function R() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R Component</h1>
      <p>This is the R tutorial section.</p>
    </div>
  );
}
